export const generateThumbnail = (videoFile) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const url = URL.createObjectURL(videoFile);
    video.src = url;

    // Once the video metadata is loaded (like duration and dimensions)
    video.onloadedmetadata = () => {
      // Set video dimensions for the canvas
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Seek to the middle of the video to capture the thumbnail
      video.currentTime = video.duration / 2;
    };

    // Once the video has loaded the current frame at currentTime, capture the frame
    video.onseeked = () => {
      // Draw the video frame to the canvas
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Convert the canvas to a data URL (base64 encoded image)
      const thumbnailDataUrl = canvas.toDataURL("image/png");
      resolve(thumbnailDataUrl);

      // Clean up
      URL.revokeObjectURL(url);
    };
  });
};
